// @flow
import {
  CREATE,
  GET,
  GET_BY_ID,
  GET_FOR_APP,
  GET_FOR_MAINTAINER,
  GET_BY_NAME,
  GET_FOR_FLOW,
  UPDATE,
  ADD_AFFILIATE,
  REMOVE_AFFILIATE,
  GET_ALL,
  DELETE,
  REGISTER_TASK
} from './action-types'

import { ADD_TASK, COMPLETE_TASK, REMOVE_TASK } from './mutation-types'

export default {
  [GET]({ dispatch }, typename: string) {
    return dispatch(typename + '/' + GET_ALL, { typename })
  },
  [GET_BY_ID]({ dispatch }, { typename, id }: { typename: string, id: string }) {
    return dispatch(typename + '/' + GET_BY_ID, { typename, id })
  },
  [GET_FOR_APP]({ dispatch }, { typename, appId }: { typename: string, appId: string }) {
    return dispatch(typename + '/' + GET_FOR_APP, { typename, appId })
  },
  [GET_FOR_FLOW]({ dispatch }, { typename, flowId }: { typename: string, flowId: string }) {
    return dispatch(typename + '/' + GET_FOR_FLOW, { typename, flowId })
  },
  [GET_FOR_MAINTAINER]({ dispatch }, { typename, userId }: { typename: string, userId: string }) {
    return dispatch(typename + '/' + GET_FOR_MAINTAINER, { typename, userId })
  },
  [GET_BY_NAME]({ dispatch }, { typename, name }: { typename: string, name: string }) {
    return dispatch(typename + '/' + GET_BY_NAME, { typename, name })
  },
  [CREATE](
    { dispatch },
    {
      typename,
      item,
      uniqueConstraints = []
    }: { typename: string, item: Object, uniqueConstraints: ?Array<string> }
  ) {
    return dispatch(typename + '/' + CREATE, { typename, item, uniqueConstraints })
  },
  [UPDATE](
    { dispatch },
    {
      typename,
      id,
      item,
      uniqueConstraints = []
    }: { typename: string, id: string, item: Object, uniqueConstraints: ?Array<string> }
  ) {
    return dispatch(typename + '/' + UPDATE, { typename, id, item, uniqueConstraints })
  },
  [ADD_AFFILIATE](
    { dispatch },
    {
      typename,
      affiliateTypename,
      affiliateId,
      id
    }: { typename: string, affiliateTypename: string, affiliateId: string, id: string }
  ) {
    return dispatch(typename + '/' + ADD_AFFILIATE, {
      typename,
      affiliateTypename,
      affiliateId,
      id
    })
  },
  [REMOVE_AFFILIATE](
    { dispatch },
    {
      typename,
      affiliateTypename,
      affiliateId,
      id
    }: { typename: string, affiliateTypename: string, affiliateId: string, id: string }
  ) {
    return dispatch(typename + '/' + REMOVE_AFFILIATE, {
      typename,
      affiliateTypename,
      affiliateId,
      id
    })
  },
  [DELETE]({ dispatch }, { typename, id }: { typename: string, id: string }) {
    return dispatch(typename + '/' + DELETE, { typename, id })
  },
  [REGISTER_TASK]({ commit }, { task, promise }) {
    promise.finally(() => {
      commit(COMPLETE_TASK, task)
      setTimeout(() => {
        commit(REMOVE_TASK, task)
      }, 10000) // Allow some time to see the task
    })
    return commit(ADD_TASK, task)
  }
}
